<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Class Recommendation And Notes &nbsp;
          <add-button
            link="/planned-maintenance/class-recommendation-and-notes/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Class Recommendation And Notes</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="ExportCRANotes.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="class_recommendation_and_note_excel"
                :fields="excel_fields"
                worksheet="Class Recommendation And Notes"
                name="Class Recommendation And Note.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Survey Date</th>
                    <th>Survey Type</th>
                    <th>Survey Name</th>
                    <th>Survey Carried Out By</th>
                    <th>Issued By</th>
                    <th>Issue Date</th>
                    <th>Expired Date</th>
                    <th>Trigger Alert</th>
                    <th>Alert Date</th>
                    <th>Place Of Issue</th>
                    <th>Class Recommendation And Note</th>
                    <th>Attachment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="15"
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="CRANotes.length == 0">
                    <td colspan="15" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr v-for="(CRANote, at) in CRANotes" :key="`CRANote${at}`">
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>
                      {{ CRANote.vessel ? CRANote.vessel.name : "" }}
                    </td>
                    <td>
                      {{ CRANote ? CRANote.survey_date : "" | ddmmyyyy }}
                    </td>
                    <td>{{ CRANote.survey_type }}</td>
                    <td>{{ CRANote.survey_name }}</td>
                    <td>{{ CRANote.survey_carried_out_by }}</td>
                    <td>{{ CRANote.issued_by }}</td>
                    <td>{{ CRANote.issued_date | ddmmyyyy }}</td>
                    <td>{{ CRANote.expired_date | ddmmyyyy }}</td>
                    <td>{{ CRANote.trigger_alert == true ? "YES" : "NO" }}</td>
                    <td>{{ CRANote.trigger_alert | ddmmyyyy }}</td>
                    <td>{{ CRANote.place_of_issue }}</td>
                    <td>{{ CRANote.class_recommendation_and_notes }}</td>
                    <td>
                      <img
                        v-if="CRANote.attchment"
                        :src="`${mediaUrl + CRANote.attchment}`"
                        alt=""
                        srcset=""
                      />
                      <span v-else></span>
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/class-recommendation-and-notes/${CRANote.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(CRANote.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "CRANote",
  data() {
    return {
      CRANotes: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      class_recommendation_and_note_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        "Survey Date": "survey_date",
        "Survey Type": "survey_type",
        "Survey Name": "survey_name",
        "Survey Carried Out By": "survey_carried_out_by",
        "Issued By": "issued_by",
        "Issue Date": "issued_date",
        "Expired Date": "expired_date",
        "Trigger Alert": "trigger_alert",
        "Alert Date": "alert_date",
        "Place Of Issue": "place_of_issue",
        "Class Recommendation And Note": "class_recommendation_and_notes",
      },
      ExportCRANotes: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let CRANotes = await axios.get(
        `/class_recommendation_and_notes?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.CRANotes = CRANotes.data.data;
      this.count = CRANotes.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let CRANotes = await axios.get(
        `/class_recommendation_and_notes?search=${this.searchData}`
      );
      this.CRANotes = CRANotes.data.data;
      this.count = CRANotes.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Office Job Scheduler Data";
      this.class_recommendation_and_note_excel = [];
      let ExportCRANotes = [];
      ExportCRANotes = await axios.get(`/class_recommendation_and_notes`);
      this.ExportCRANotes = ExportCRANotes.data.data;
      let sr_no = 1;
      this.ExportCRANotes.forEach((CRANote) => {
        this.class_recommendation_and_note_excel.push({
          sr_no: sr_no,
          job_title: CRANote.job_title ? CRANote.job_title : "",
          vessel: CRANote.vessel ? CRANote.vessel.name : "",
          survey_date: CRANote.survey_date ? CRANote.survey_date : "",
          survey_type: CRANote.survey_type ? CRANote.survey_type : "",
          survey_name: CRANote.survey_name ? CRANote.survey_name : "",
          survey_carried_out_by: CRANote.survey_carried_out_by
            ? CRANote.survey_carried_out_by
            : "",
          issued_by: CRANote.issued_by ? CRANote.issued_by : "",
          issued_date: CRANote.issued_date ? CRANote.issued_date : "",
          expired_date: CRANote.expired_date ? CRANote.expired_date : "",
          trigger_alert: CRANote.trigger_alert == true ? "YES" : "NO",
          alert_date: CRANote.alert_date ? CRANote.alert_date : "",
          place_of_issue: CRANote.place_of_issue ? CRANote.place_of_issue : "",
          class_recommendation_and_notes: CRANote.class_recommendation_and_notes
            ? CRANote.class_recommendation_and_notes
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=class_recommendation_and_notes`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
